import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews';
import Vue from 'vue';

/**
 * Include our required Concord modules.
 *
 * We include CSS here so we can support nested import globbing.
 */
require('@galaxy/modules/Admin/resources/js/bootstrap.js');
require('@galaxy/modules/Canvas/resources/js/bootstrap.admin.js');
require('@galaxy/modules/Crud/resources/js/bootstrap.js');
require('@galaxy/modules/Website/resources/js/bootstrap.admin.js');
require('@galaxy/modules/WebsiteForms/resources/js/bootstrap.admin.js');

AutoloadViews.load('admin', require.context('./admin/', true, /.(js|vue)$/));

// Vue.component('admin-dashboard', require('./admin/dashboard/Dashboard.vue').default);
